import { createFileRoute, Navigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { BookmarksManagePage, type BookmarksManageTab } from '@/features/bookmarks';

function BookmarksRoute(): ReactNode {
  const search = Route.useSearch();
  if (search.tab === 'read-later') return <Navigate to="/read-later" replace />;
  return (
    <AuthGuard>
      <BookmarksManagePage />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/bookmarks')({
  validateSearch,
  component: BookmarksRoute,
});

function validateSearch(raw: Record<string, unknown>): { tab?: BookmarksManageTab } {
  if (raw.tab === 'collections') return { tab: 'collections' };
  if (raw.tab === 'read-later') return { tab: 'read-later' };
  return {};
}
